import { createContext } from "react";
import { IError, IField } from ".";
import { ReactInputMask } from "react-input-mask";

interface I {
  getField(name: string): IField | undefined | void;
  registerField?(
    name: string,
    ref: HTMLInputElement | ReactInputMask | HTMLTextAreaElement,
    status: boolean,
    checkForm: boolean
  ): void;
  setFieldError?(name: string, error: IError): void;
  deleteField?(name: string): void;
  submitted?: boolean;
  fields?: IField[]; // Adicione esta linha
  hasErrors?: boolean; // Adicione esta linha
}
export default createContext<I>({ getField: () => {} });
